import { BASE_URL } from "../../../shared/utils/variables";
import { getAuthHeaders } from "../../../shared/services/authentication";

const baseURL = BASE_URL;

interface FinancierPayload {
    name: string;
    description: string;
    idCompany?: string;
}

export const fetchFinancier = async (id: string,) => {
    const url = `${baseURL}/financier/${id}`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || `Erro HTTP ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
}

export const fetchFinanciersService = async () => {
    const url = `${baseURL}/financiers`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || `Erro HTTP ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        throw error;
    }
}

export const createFinancierService = async (payload: FinancierPayload) => {
    const url = `${baseURL}/financier`;

    const options = {
        method: 'POST',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
}

export const updateFinancierService = async (id: string, payload: FinancierPayload) => {
    const url = `${baseURL}/financier/${id}`;

    const options = {
        method: 'PUT',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
}
